import React from 'react';
import { useSelector } from 'react-redux';
import Button from '../Button/Button';
import { useAlertDialog } from '../ConfirmDialog/ConfirmDialogProvider';
import PlayerList from './PlayerList';
import './GameSettlement.css';

const GameSettlement = ({
  onSettle,
  isSettling = false,
  runAuthedRequest,
  onAuthFailure,
}) => {
  const { game } = useSelector((state) => state.game);
  const showAlert = useAlertDialog();

  if (!game?.teams) return null;

  const pendingCashCount = game.teams
    .flat()
    .filter(
      (player) =>
        player &&
        (player.paymentMethod === 'cash' || player.paymentStatus === 'pending_cash' || player.paymentStatus === 'paid_cash') &&
        player.paymentStatus === 'pending_cash'
    ).length;

  const canSettle = pendingCashCount === 0;

  const handleSettleClick = async () => {
    if (!canSettle) {
      await showAlert({
        title: 'SETTLEMENT',
        message: `You still have ${pendingCashCount} pending cash payment(s).`,
      });
      return;
    }

    onSettle();
  };

  return (
    <div className="gset-container">
      <div className="gset-header">
        <h2 className="gset-title">Game Settlement</h2>
        <p className="gset-subtitle">
          {canSettle
            ? 'All cash payments are settled. You can now close this game.'
            : `${pendingCashCount} cash payment(s) pending.`}
        </p>
        <Button
          text={isSettling ? 'Settling...' : 'Settle'}
          onClick={handleSettleClick}
          disabled={!canSettle || isSettling}
        />
      </div>

      <PlayerList
        settlementMode
        runAuthedRequest={runAuthedRequest}
        onAuthFailure={onAuthFailure}
      />
    </div>
  );
};

export default GameSettlement;
